/* global Office */
export function openTaskpaneDialog(options) {
    if (options.requireAuth && options.isAuthenticated && !options.isAuthenticated()) {
        return false;
    }
    Office.context.ui.displayDialogAsync(options.dialogUrl, {
        height: options.options?.height ?? 60,
        width: options.options?.width ?? 40,
        displayInIframe: options.options?.displayInIframe ?? false,
        promptBeforeOpen: options.options?.promptBeforeOpen ?? false,
    }, (result) => {
        if (result.status !== Office.AsyncResultStatus.Succeeded) {
            options.onOpenFailed?.(result.error);
            return;
        }
        const dialog = result.value;
        options.onOpened?.(dialog);
        if (options.onMessage) {
            dialog.addEventHandler(Office.EventType.DialogMessageReceived, (args) => {
                if ("message" in args) {
                    const messageArgs = {
                        message: args.message,
                        origin: args.origin,
                        type: Office.EventType.DialogMessageReceived,
                    };
                    options.onMessage?.(messageArgs, dialog);
                }
            });
        }
        if (options.onDialogEvent) {
            dialog.addEventHandler(Office.EventType.DialogEventReceived, (args) => {
                if ("message" in args) {
                    options.onDialogEvent?.({
                        message: args.message,
                        origin: args.origin ?? "",
                    }, dialog);
                    return;
                }
                options.onDialogEvent?.(args, dialog);
            });
        }
    });
    return true;
}
